<template>
    <common-content-spacer height="small">
        <common-page-header
            :heading="$t('modals.make_direct_referal_modal.invite.heading', { name: name })"
            :content="$t('modals.make_direct_referal_modal.invite.content')"
            :isCenter="true"
            contentSpacing="medium"
            size="minor"
        ></common-page-header>
        <common-content-wrapper width="small">
            <form-wrapper @submit="inviteMember(data)">
                <form-row>
                    <form-cell>
                        <import-contacts
                            :showAsInnerModal="true"
                            :sendButtonLabel="$t('modals.make_direct_referal_modal.invite.buttons.collect_contacts')"
                            :prefillUser="name"
                            :showSearchBar="true"
                            :maxSelectedContacts="1"
                            @contacts-emails-collected="collectContactsEmails"
                        ></import-contacts>
                    </form-cell>
                </form-row>
                <form-row class="email-collector--name-row">
                    <form-cell width="half">
                        <text-field
                            :label="$t('elements.network.email_collector.first_name')"
                            :placeholder="$t('elements.network.email_collector.first_name')"
                            :formData="data"
                            valuePath="firstName"
                            errorPath="firstName.0"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            :label="$t('elements.network.email_collector.last_name')"
                            :placeholder="$t('elements.network.email_collector.last_name')"
                            :formData="data"
                            valuePath="lastName"
                            errorPath="lastName.0"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell>
                        <text-field
                            :label="$t('forms.auth.login.fields.email.label')"
                            :placeholder="$t('forms.auth.login.fields.email.placeholder')"
                            :isRequired="true"
                            :formData="data"
                            :error="errorMessage"
                            valuePath="email"
                            errorPath="emails.0"
                            type="email"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>

                <template #footer>
                    <common-buttons>
                        <common-button
                            :isProcessing="isSending"
                            :label="$t('modals.make_direct_referal_modal.invite.buttons.send_invite')"
                            type="primary"
                        ></common-button>
                    </common-buttons>
                </template>
            </form-wrapper>
        </common-content-wrapper>
    </common-content-spacer>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'
    import UserRolesEnum from '../../../enums/UserRolesEnum'
    import ImportContacts from './ImportContacts.vue'

    export default {
        mixins: [FormMixin],

        components: {
            ImportContacts,
        },

        props: {
            name: { type: String, required: true },
        },

        data() {
            return {
                isSending: false,
                errorMessage: null,
            }
        },

        methods: {
            inviteMember(data) {
                this.errorMessage = null
                this.isSending = true
                UsersAPI.checkJoinInvitesEmails(
                    this.$auth.getActiveMember().id,
                    [{ email: data.email }],
                    this.$auth.getPractice().practiceType,
                )
                    .then((res) => {
                        const newInvitations = res.emailsCheck.newInvitations
                        if (newInvitations.length) {
                            let request = [
                                {
                                    email: data.email,
                                    firstName: data.firstName,
                                    lastName: data.lastName,
                                },
                            ]

                            this.sendInvitesToNetwork(request)
                        } else {
                            this.isSending = false
                            this.setInviteErrorMessage(res.emailsCheck)
                        }
                    })
                    .catch(() => (this.isSending = false))
            },

            setInviteErrorMessage(emailsCheck) {
                if (emailsCheck.invited.length) {
                    this.errorMessage = this.$t('modals.make_direct_referal_modal.invite.already_invited', {
                        email: emailsCheck.invited[0].email,
                    })
                } else {
                    const registeredUsers = emailsCheck.registeredInvites.concat(emailsCheck.registeredOther)
                    const user = registeredUsers[0]
                    if (user.isRemoved) {
                        this.errorMessage = this.$t('modals.make_direct_referal_modal.invite.already_deactivated', {
                            name: `${user.firstName} ${user.lastName}`,
                        })
                    } else {
                        this.errorMessage = this.$t('modals.make_direct_referal_modal.invite.already_registered', {
                            name: `${user.firstName} ${user.lastName}`,
                        })
                    }
                }
            },

            sendInvitesToNetwork(emails) {
                const practiceType = this.$auth.getPractice().practiceType
                UsersAPI.createJoinNetworkInvites(
                    this.$auth.getActiveMember().id,
                    emails,
                    practiceType,
                    practiceType === 'physician' ? UserRolesEnum.PHYSICIAN.ID : null,
                ).then(() => {
                    this.isSending = false
                    this.$emit('invite-sent', emails)
                    this.emitEvent({ name: 'join-invite-sent', payload: { email: emails[0] } })
                })
            },
            collectContactsEmails(email) {
                this.prefillData({
                    email: email[0].emails[0].email,
                    firstName: email[0].firstName,
                    lastName: email[0].lastName,
                })
            },
        },
    }
</script>
